import { ShieldCheck } from "lucide-react";
import type { AdminRolePillProps } from "./types";

export const AdminRolePill = ({ label }: AdminRolePillProps) => (
  <span className="inline-flex items-center gap-1 rounded-full bg-blue-50 px-3 py-1 text-sm font-medium text-blue-700 ring-1 ring-inset ring-blue-200">
    <ShieldCheck className="h-4 w-4" />
    {label}
  </span>
);
